import { __extends } from "tslib";
import { AbstractMethodError, AbstractionBase } from '@awayjs/core';
/**
 *
 * @class away.pool._Shader_TextureBaseBase
 */
var _Shader_TextureBase = /** @class */ (function (_super) {
    __extends(_Shader_TextureBase, _super);
    function _Shader_TextureBase(texture, shader) {
        var _this = _super.call(this, texture, shader) || this;
        _this._texture = texture;
        _this._shader = shader;
        _this._stage = shader._stage;
        return _this;
    }
    /**
     *
     */
    _Shader_TextureBase.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._texture = null;
        this._shader = null;
        this._stage = null;
    };
    /**
     * Initializes the properties for a MethodVO, including register and texture indices.
     *
     * @param methodVO The MethodVO object linking this method with the pass currently being compiled.
     *
     * @internal
     */
    _Shader_TextureBase.prototype._initVO = function (chunkVO) {
    };
    /**
     * Initializes unchanging shader constants using the data from a MethodVO.
     *
     * @param methodVO The MethodVO object linking this method with the pass currently being compiled.
     *
     * @internal
     */
    _Shader_TextureBase.prototype._initConstants = function () {
    };
    _Shader_TextureBase.prototype._getFragmentCode = function (targetReg, regCache, sharedReg, inputReg) {
        if (inputReg === void 0) { inputReg = null; }
        throw new AbstractMethodError();
    };
    _Shader_TextureBase.prototype._setRenderState = function (renderState) {
        //overidden for state logic
    };
    _Shader_TextureBase.prototype.activate = function () {
        //overridden for activation logic
    };
    _Shader_TextureBase.prototype.getTextureReg = function (imageIndex, regCache, sharedReg) {
        //todo: collapse the index based on duplicate image objects to save registrations
        var index = this._shader.imageIndices.indexOf(imageIndex);
        if (index == -1) {
            var textureReg = regCache.getFreeTextureReg();
            sharedReg.textures.push(textureReg);
            this._shader.imageIndices.push(imageIndex);
            return textureReg;
        }
        return sharedReg.textures[index];
    };
    return _Shader_TextureBase;
}(AbstractionBase));
export { _Shader_TextureBase };
